
import { mapState, mapMutations, mapActions } from 'vuex'
import DefaultForm from '@pleinair/bigcolony-vue/components/_globals/forms/DefaultForm.vue'

export default {
  name: 'SigninForm',
  components: {
    DefaultForm
  },
  props: {
    provider: {
      type: String,
      default: 'olo',
      validator: (value) => {
        return ['olo', 'spendgo', 'punchh'].includes(value)
      }
    },
    forgotPlacement: {
      type: String,
      default: 'none',
      validator: (value) => {
        return ['none', 'below', 'onElement'].includes(value)
      }
    },
    forgotLanguage: {
      type: String,
      default: 'Forgot Password?',
    },
    signinLanguage: {
      type: String,
      default: 'Sign In'
    },
    appLayout: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function,
      default: () => { }
    },
    formData: {
      type: Object,
      default: () => { }
    }
  },
  mounted() {
    this.bindEvents()
    this.method = this.formData?.method
  },
  computed: {
    ...mapState(['appState']),
    email() {
      let email = this.formData?.email ? this.formData.email : ""
      let start = 3
      let end = email.indexOf("@")
      if (end) {
        let arr = email.split('')
        for (let i = start; i < end; i++) {
          arr[i] = '*'
        }
        email = arr.join('')
      }

      return email
    },
    code() {
      return this.digit1 + this.digit2 + this.digit3 + this.digit4 + this.digit5 + this.digit6
    },
  },
  data() {
    let fields = []
    // create email field element
    let email = {
      name: 'method',
      label: 'Email',
      type: 'radio',
      value: 'email'
    }

    // create email field element
    // let sms = {
    //   name: 'method',
    //   label: 'SMS',
    //   type: 'radio',
    //   value: 'sms'
    // }

    // populate the fields object
    fields = [email].concat(fields)

    return {
      fields,
      message: null,
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
      method: 'email'
    }
  },
  methods: {
    ...mapMutations(['setLoading', 'setErrors']),
    ...mapActions(['sendRequest', 'trackEvent']),
    async handleCodeEntrySubmit() {
      this.setLoading(true)
      let data = this.formData
      if (this.appState && this.appState.cart_id) {
        data.cart_id = this.appState.cart_id
      } else if (this.cart) {
        data.cart_id = this.cart.id
      }
      data.code = this.code
      let config = {
        method: 'post',
        url: 'members/auth',
        headers: {
          verify: true
        },
        data
      }
      const response = await this.sendRequest(config)
      if (response.status === 'ok') {
        this.trackEvent({
          name: 'sign_in',
          windowObject: window
        });
        this.onSuccess(response.data)
      } else {
        this.clearValues()
        this.setErrors(response.message)
      }
      this.setLoading(false)
    },
    async changeVerify() {
      this.setLoading(true)
      this.clearValues()
      let data = this.formData
      delete data.code
      delete data.session
      if (this.appState && this.appState.cart_id) {
        data.cart_id = this.appState.cart_id
      } else if (this.cart) {
        data.cart_id = this.cart.id
      }
      data.method = this.method === 'email' ? 'sms' : 'email'
      let config = {
        method: 'post',
        url: 'members/auth',
        headers: {
          verify: true
        },
        data
      }
      const response = await this.sendRequest(config)
      if (response.status === 'validate') {
        this.formData.session = response?.data?.session
        this.method = data.method
      } else {
        this.setErrors(response.message)
      }
      this.setLoading(false)
    },
    async verifyAgain() {
      this.setLoading(true)
      this.clearValues()
      let data = this.formData
      delete data.code
      delete data.session
      if (this.appState && this.appState.cart_id) {
        data.cart_id = this.appState.cart_id
      } else if (this.cart) {
        data.cart_id = this.cart.id
      }
      let config = {
        method: 'post',
        url: 'members/auth',
        headers: {
          verify: true
        },
        data
      }
      const response = await this.sendRequest(config)
      if (response.status === 'validate') {
        this.formData.session = response?.data?.session
      } else {
        this.setErrors(response.message)
      }
      this.setLoading(false)
    },
    getCode() {
      return this.digit1 + this.digit2 + this.digit3 + this.digit4 + this.digit5 + this.digit6
    },
    clearValues() {
      this.digit1 = ''
      this.digit2 = ''
      this.digit3 = ''
      this.digit4 = ''
      this.digit5 = ''
      this.digit6 = ''
    },
    cancelVerify() {
      this.$parent.code = false
      this.$parent.form = true
    },
    bindEvents() {
      document.querySelector(".digits").addEventListener("input", function (e) {
        // Exclude non-numeric characters from input:
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // If the input value is filled and there is a neighbouring element that is input, then focus on that element:
        if (e.target.value !== "" && e.target.nextElementSibling && e.target.nextElementSibling.nodeName === "INPUT") {
          e.target.nextElementSibling.focus();
        }
      })
      document.querySelector(".digits").addEventListener("paste", this.pasteEvent)
    },
    pasteEvent(e) {
      let data = e.clipboardData.getData("text/plain")
      let newArray = data.trim().split('')
      if (newArray.length === 6) {
        this.digit1 = newArray[0]
        this.digit2 = newArray[1]
        this.digit3 = newArray[2]
        this.digit4 = newArray[3]
        this.digit5 = newArray[4]
        this.digit6 = newArray[5]
      }
      e.preventDefault();
    }
  }
}
